import createIcon from '../../createIcon';

/**
 * @component @name Leaderboard
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy41IDIxSDJWOUg3LjVWMjFaTTE0Ljc1IDNIOS4yNVYyMUgxNC43NVYzWk0yMiAxMUgxNi41VjIxSDIyVjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Leaderboard = createIcon('Leaderboard', [
  [
    'path',
    { d: 'M7.5 21H2V9H7.5V21ZM14.75 3H9.25V21H14.75V3ZM22 11H16.5V21H22V11Z', key: 'c3mtsk' },
  ],
]);

export default Leaderboard;
